<template>
  <div class="index">
    <div class="list">
      <div
        class="item"
        @click="
          $router.push({
            path: '/recede/refundmoney',
            query: $route.query
          })
        "
      >
        <div class="title"><div class="title-word">退</div></div>
        <div class="word">
          <div class="word-title">我要退款退货</div>
          <div class="word-name">已收到货，需要退还已收到的货品</div>
        </div>
      </div>
      <div
        class="item"
        @click="
          $router.replace({ path: '/recede/exchange', query: $route.query })
        "
      >
        <div class="title"><div class="title-word">换</div></div>
        <div class="word">
          <div class="word-title">我要换货</div>
          <div class="word-name">对收到的商品不满意，可与商家协商换货</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "refund",
  components: {},
  data() {
    return {
      orderid: 0
    };
  },
  methods: {},
  mounted() {}
};
</script>
<style scoped="scoped">
.index {
  background-color: #f4f4f4;
}
.list {
  width: 100%;
  height: auto;
  padding: 15px;
  box-sizing: border-box;
}
.item {
  width: 100%;
  height: 100px;
  background-color: #ffffff;
  border-radius: 5px;
  margin-bottom: 20px;
  display: flex;
}
.item .title {
  width: 20%;
  height: 100%;
  position: relative;
}
.item .title .title-word {
  width: 25px;
  height: 25px;
  box-sizing: border-box;
  background-image: linear-gradient(#fa342b, #fb6b2e);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  font-size: 12px;
  text-align: center;
  line-height: 25px;
  color: #fff;
}
.item .word {
  width: 80%;
  height: 100%;
  line-height: 30px;
}
.word-title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin-top: 22px;
}
.word-name {
  color: #555555;
  font-size: 12px;
}
</style>
